/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, TabPanel } from '@coursera/cds-core';

import { CalendarSyncCard } from 'bundles/degree-home/components/v2/Calendar/CalendarSyncCard';
import { RecentGradesCard } from 'bundles/degree-home/components/v2/RecentGrades';
import SlackAccountInfoCard from 'bundles/degree-home/components/v2/SlackAccountInfoCard';
import SupportInfoCard from 'bundles/degree-home/components/v2/SupportInfoCard';
import type { DegreeMetadata } from 'bundles/degree-home/types/Degree';

import { CalendarCard, MobileCalendarCard } from './Calendar';
import { CurrentCoursesCard } from './CurrentCourses';
import { EnrollmentReminderBanner } from './EnrollmentReminder';
import { UpcomingCoursesCard } from './UpcomingCourses';

type Props = {
  degreeMetadata: DegreeMetadata;
};

export const DegreeHomeV2 = (props: Props) => {
  const { id: degreeId, supportEmailAddress, supportLink } = props.degreeMetadata;
  return (
    <>
      <TabPanel value="home">
        <Grid container spacing={{ xs: 24, sm: 32 }}>
          <Grid item xs={12}>
            <EnrollmentReminderBanner />
          </Grid>
          <Grid item xs={12} md={6}>
            <UpcomingCoursesCard supportEmailAddress={supportEmailAddress} />
            <CurrentCoursesCard />
            <MobileCalendarCard degreeId={degreeId} />
            <RecentGradesCard degreeId={degreeId} />
            <SlackAccountInfoCard degreeId={degreeId} />
            <CalendarSyncCard />
            <SupportInfoCard degreeId={degreeId} supportEmailAddress={supportEmailAddress} supportLink={supportLink} />
          </Grid>
          <Grid item md={6}>
            <CalendarCard degreeId={degreeId} />
          </Grid>
        </Grid>
      </TabPanel>
    </>
  );
};

export default DegreeHomeV2;
